import QuickTip from "./QuickTip";

export default QuickTip;
